var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { Animated, Easing } from 'react-native';
export const AnimatedScreenContainerView = (_a) => {
    var { navigation, children, style } = _a, otherProps = __rest(_a, ["navigation", "children", "style"]);
    const animation = useRef(new Animated.Value(0)).current;
    useEffect(() => {
        Animated.timing(animation, {
            useNativeDriver: false,
            toValue: 1,
            duration: 300,
            easing: Easing.linear
        }).start();
        const focusListener = navigation === null || navigation === void 0 ? void 0 : navigation.addListener('transitionStart', () => {
            Animated.timing(animation, {
                useNativeDriver: false,
                toValue: 1,
                duration: 300,
                easing: Easing.linear
            }).start();
        });
        const blurListener = navigation === null || navigation === void 0 ? void 0 : navigation.addListener('transitionEnd', () => {
            Animated.timing(animation, {
                useNativeDriver: false,
                toValue: 0,
                duration: 300,
                easing: Easing.linear
            }).start();
        });
        return () => {
            focusListener === null || focusListener === void 0 ? void 0 : focusListener();
            blurListener === null || blurListener === void 0 ? void 0 : blurListener();
        };
    }, []);
    return (_jsx(Animated.View, Object.assign({}, otherProps, { style: [style, { opacity: animation }], children: children })));
};
